import { useStatsigClient } from "@statsig/react-bindings";
import { useMemo } from "react";

/**
 * Custom hook to check if Product Feed Card is enabled.
 * Returns a boolean indicating whether the "enable_product_feed_card"
 * feature gate is enabled on Statsig.
 */
export const useEnableProductFeedCard = (): boolean => {
  const statsigClient = useStatsigClient();
  const enableProductFeedCard = statsigClient.checkGate(
    "enable_product_feed_card",
  );

  return useMemo(() => enableProductFeedCard, [enableProductFeedCard]);
};
